import * as React from 'react'

export const AstarNaked = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 77 55"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'test'}</title>
    <defs>
      <linearGradient
        x1="15.8775462%"
        y1="83.9675509%"
        x2="79.6268575%"
        y2="20.3242755%"
        id="linearGradientastaricon-1"
      >
        <stop stopColor="#E6007A" offset="0%" />
        <stop stopColor="#703AC2" offset="21%" />
        <stop stopColor="#0070EB" offset="46%" />
        <stop stopColor="#0297FB" offset="77%" />
        <stop stopColor="#0AE2FF" offset="100%" />
      </linearGradient>
      <radialGradient
        cx="57.7159655%"
        cy="47.0296305%"
        fx="57.7159655%"
        fy="47.0296305%"
        r="110.67099%"
        gradientTransform="translate(0.577160,0.470296),scale(1.000000,0.337563),translate(-0.577160,-0.470296)"
        id="radialGradient-2"
      >
        <stop stopColor="#FFFFFF" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="100%" />
      </radialGradient>
      <radialGradient
        cx="56.098142%"
        cy="42.9889651%"
        fx="56.098142%"
        fy="42.9889651%"
        r="131.756022%"
        gradientTransform="translate(0.560981,0.429890),scale(0.278786,1.000000),translate(-0.560981,-0.429890)"
        id="radialGradient-3"
      >
        <stop stopColor="#FFFFFF" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="100%" />
      </radialGradient>
      <linearGradient
        x1="3.78648435%"
        y1="50.1293544%"
        x2="42.8608993%"
        y2="50.0468587%"
        id="linearGradientastaricon-4"
      >
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <radialGradient
        cx="43.1484369%"
        cy="37.2165293%"
        fx="43.1484369%"
        fy="37.2165293%"
        r="71.9169589%"
        gradientTransform="translate(0.431484,0.372165),scale(0.571454,1.000000),rotate(-120.043415),translate(-0.431484,-0.372165)"
        id="radialGradient-5"
      >
        <stop stopColor="#FFFFFF" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="100%" />
      </radialGradient>
      <radialGradient
        cx="44.9986167%"
        cy="42.0301421%"
        fx="44.9986167%"
        fy="42.0301421%"
        r="62.6517217%"
        gradientTransform="translate(0.449986,0.420301),scale(1.000000,0.674973),rotate(-120.043415),translate(-0.449986,-0.420301)"
        id="radialGradient-6"
      >
        <stop stopColor="#FFFFFF" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="100%" />
      </radialGradient>
      <linearGradient
        x1="70.9369956%"
        y1="95.7548333%"
        x2="54.5348526%"
        y2="55.6381588%"
        id="linearGradientastaricon-7"
      >
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <radialGradient
        cx="44.676902%"
        cy="58.4427758%"
        fx="44.676902%"
        fy="58.4427758%"
        r="56.0890899%"
        gradientTransform="translate(0.446769,0.584428),scale(0.771617,1.000000),rotate(120.043415),translate(-0.446769,-0.584428)"
        id="radialGradient-8"
      >
        <stop stopColor="#FFFFFF" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="100%" />
      </radialGradient>
      <radialGradient
        cx="38.3224089%"
        cy="54.2611369%"
        fx="38.3224089%"
        fy="54.2611369%"
        r="72.6275892%"
        gradientTransform="translate(0.383224,0.542611),scale(1.000000,0.586603),rotate(120.043415),translate(-0.383224,-0.542611)"
        id="radialGradient-9"
      >
        <stop stopColor="#FFFFFF" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="100%" />
      </radialGradient>
      <linearGradient
        x1="61.3190551%"
        y1="3.31116689%"
        x2="50.5787218%"
        y2="41.4367546%"
        id="linearGradientastaricon-10"
      >
        <stop stopColor="#FFFFFF" stopOpacity={0} offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="68.2121972%"
        y1="46.1035168%"
        x2="36.5914787%"
        y2="50.2615628%"
        id="linearGradientastaricon-11"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="29.0535472%"
        y1="33.6016612%"
        x2="55.3137501%"
        y2="53.4912937%"
        id="linearGradientastaricon-12"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="47.3320886%"
        y1="52.5461524%"
        x2="52.0058208%"
        y2="15.8365723%"
        id="linearGradientastaricon-13"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="27.6147331%"
        y1="49.8610123%"
        x2="87.5714004%"
        y2="54.0032685%"
        id="linearGradientastaricon-14"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="60.4178627%"
        y1="34.5792069%"
        x2="34.5720391%"
        y2="83.5031018%"
        id="linearGradientastaricon-15"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="53.0937624%"
        y1="79.9224429%"
        x2="36.2651658%"
        y2="7.6366272%"
        id="linearGradientastaricon-16"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="65.6029081%"
        y1="34.8179927%"
        x2="34.9695196%"
        y2="84.6621653%"
        id="linearGradientastaricon-17"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="27.053133%"
        y1="41.7094022%"
        x2="95.6561786%"
        y2="62.2230158%"
        id="linearGradientastaricon-18"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="55.8913663%"
        y1="65.5499133%"
        x2="38.6164625%"
        y2="29.8763777%"
        id="linearGradientastaricon-19"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="27.0410914%"
        y1="83.0250991%"
        x2="43.8495134%"
        y2="56.67107%"
        id="linearGradientastaricon-20"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="73.9491046%"
        y1="38.0681528%"
        x2="52.1583412%"
        y2="44.7043374%"
        id="linearGradientastaricon-21"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="33.7078485%"
        y1="9.06073681%"
        x2="43.9839935%"
        y2="33.7205443%"
        id="linearGradientastaricon-22"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="53.958904%"
        y1="63.164668%"
        x2="48.9288636%"
        y2="50.2696509%"
        id="linearGradientastaricon-23"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="37.8527302%"
        y1="47.2443615%"
        x2="43.4603673%"
        y2="50.0423944%"
        id="linearGradientastaricon-24"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="95.8551166%"
        y1="56.3943328%"
        x2="63.4655054%"
        y2="52.8293971%"
        id="linearGradientastaricon-25"
      >
        <stop stopColor="#231F20" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <g
        id="test"
        transform="translate(-88.000000, -8.000000)"
        fillRule="nonzero"
      >
        <g id="Group-2" transform="translate(88.000000, 8.000000)">
          <g id="astar" transform="translate(11.000000, 0.000000)">
            <path
              d="M54.9297374,25.6028269 C54.1825883,14.5385337 46.8389475,5.01017005 36.3171519,1.45302293 C25.7953563,-2.10412419 14.1629971,1.00894443 6.83473457,9.34314966 L6.83473457,9.34314966 L6.83473457,9.34314966 L6.74398184,9.47313254 C1.97133581,14.9414254 -0.431378487,22.0774687 0.0637915194,29.3132474 C0.115086543,30.0301227 0.197947734,30.7351814 0.30053778,31.4363012 L0.30053778,31.4363012 C0.298642102,31.4677838 0.298642102,31.4993516 0.30053778,31.5308342 C0.367615887,31.9916826 0.446531307,32.452531 0.541229812,32.9055017 L0.541229812,32.9055017 L0.541229812,32.9291349 C0.624091003,33.3427168 0.718789507,33.748421 0.817433782,34.1501863 L0.817433782,34.1501863 C4.2487003,47.9776226 17.7070022,56.8860232 31.8019476,54.6596429 C45.896893,52.4332627 55.9425816,39.8122674 54.9297374,25.6028269 Z M48.9282197,25.9967144 C49.0541399,27.81626 48.945399,29.6444157 48.6046665,31.4363012 C48.6046665,31.4363012 48.6046665,31.4363012 48.6046665,31.4047902 L48.6046665,31.4047902 C46.6081064,26.5402792 42.68601,23.0307413 39.1979484,21.0888758 C39.9081872,12.8448098 37.0909067,9.37072178 33.9342899,8.80746261 C33.8474829,8.78776824 33.7606759,8.77595161 33.673869,8.76413499 C32.0463839,8.55305127 30.4297168,9.22473744 29.4328504,10.5261758 C28.435984,11.8276142 28.210366,13.5610853 28.8409847,15.0736074 C29.4716034,16.5861295 30.8626526,17.6479144 32.4901377,17.858998 C32.7061062,17.8852047 32.9236947,17.895736 33.1411899,17.8905091 C33.1411899,18.1701692 33.1648645,18.4655848 33.1648645,18.776756 C30.5049042,18.1036654 27.7505902,17.8813087 25.0168474,18.1189638 C24.0768906,18.1825116 23.1414612,18.30088 22.21535,18.4734626 C22.5270659,15.6886778 23.5726952,12.5651496 25.6047673,10.280602 C27.6196279,7.98553963 30.6256978,6.81047691 33.6659774,7.12950174 C34.2871565,7.19609078 34.8995313,7.328122 35.4928694,7.52338927 L35.5717848,7.54702252 L35.5717848,7.54702252 C43.1902299,10.6433646 48.3741376,17.8040704 48.9282197,25.9967144 L48.9282197,25.9967144 Z M29.779393,30.1837389 L29.779393,30.1837389 C29.0755713,31.1725298 28.2831559,32.0953989 27.4119304,32.9409516 C26.1012925,31.5601102 24.9897401,30.0037399 24.1093201,28.316712 C24.0659166,28.2300567 24.0185673,28.1473403 23.9791096,28.0606851 L23.9791096,28.0606851 C23.464142,26.9599587 23.0520343,25.814139 22.7480291,24.6378024 C24.6126789,24.1930897 26.5305636,24.0114478 28.4457224,24.0981765 L28.7377094,24.0981765 L28.7377094,24.0981765 C29.9479263,24.2015793 31.1459677,24.416507 32.3165238,24.7402132 C31.7747732,26.5740543 30.9778444,28.3229078 29.9490612,29.9355897 C29.8859288,30.022245 29.8346338,30.1049613 29.779393,30.1837389 Z M20.3845122,7.20434037 L20.3845122,7.20434037 L20.3845122,7.20434037 C17.1450342,11.3756093 16.0717845,16.5434137 16.1191338,20.5059222 C8.61822307,24.0272768 7.0083485,28.1749125 8.10132707,31.1999687 L8.19602557,31.444179 C8.83038525,32.9555382 10.2242699,34.0142563 11.8526167,34.2215244 C13.4809634,34.4287925 15.0963877,33.7531217 16.0903748,32.4490305 C17.0843618,31.1449394 17.3059014,29.4105504 16.6715417,27.8991912 C16.5864042,27.6995987 16.4875234,27.5061311 16.3756089,27.3201765 C16.6123551,27.1665604 16.8648845,27.0090054 17.1371427,26.8514504 C17.8848601,29.5027786 19.0732791,32.0099417 20.6528247,34.2683525 C21.1772293,35.046368 21.7463751,35.7933815 22.3573977,36.5056337 C19.784755,37.6282132 16.5531686,38.2860053 13.5504368,37.6872963 C10.5485057,37.0860747 8.02637306,35.0663129 6.78738532,32.2713428 C6.53677321,31.6994702 6.34763338,31.1026744 6.22314007,30.4909711 C6.14817042,29.9671007 6.08503808,29.4392914 6.04952614,28.915421 C5.40095725,19.2858751 11.2638744,10.4061827 20.3845122,7.20434037 L20.3845122,7.20434037 Z M28.9547269,48.8421911 C23.3312662,49.2299228 17.7812184,47.3902157 13.5070334,43.7216533 C18.7233426,44.4306508 23.7384176,42.7763232 27.1554553,40.7517413 C33.9579645,45.4783916 38.3693365,44.7969662 40.444812,42.3272914 C40.5039986,42.2603305 40.5592394,42.1933696 40.6144802,42.1224699 C42.0168304,40.1051926 41.5781919,37.343146 39.6195857,35.8577557 C37.6609795,34.3723654 34.8777882,34.6910035 33.3069123,36.5804723 C33.1762442,36.7547273 33.0575973,36.9376504 32.9517929,37.127976 C32.7032093,37.001932 32.4388427,36.8601325 32.1626387,36.7065163 C34.0801486,34.7318892 35.6538024,32.4514164 36.8186485,29.959223 C37.2320814,29.1154154 37.5969994,28.2487703 37.911627,27.3635041 C40.1686081,29.0257095 42.3624567,31.4914455 43.3291706,34.3943965 C44.3131589,37.2817404 43.830263,40.4663211 42.0349578,42.9338782 C41.6648518,43.4373122 41.2415308,43.8995105 40.772311,44.3124845 L40.772311,44.3124845 C37.3812834,46.9782596 33.2615717,48.5573544 28.9547269,48.8421911 L28.9547269,48.8421911 Z"
              id="Shape"
              fill="url(#linearGradientastaricon-1)"
            />
            <path
              d="M33.9342899,8.80746261 C33.8474829,8.78776824 33.7606759,8.77595161 33.673869,8.76413499 C33.2395694,8.71070771 32.7998933,8.71866374 32.3678188,8.78776824 C35.0035938,10.2136411 36.9212385,14.1800885 35.9071754,22.0578391 C35.5737099,24.6117141 34.8218775,27.093482 33.6817605,29.4038415 C32.6985692,31.5134913 31.4191039,33.4724401 29.881983,35.2215604 C30.6114118,35.7676864 31.3744442,36.2675925 32.1665845,36.718333 C34.0837773,34.7398445 35.6561377,32.4553194 36.8186485,29.959223 C37.9666673,27.6504864 38.7252355,25.1684875 39.0637922,22.6132205 C40.2475235,13.2662695 37.2960868,9.40617166 33.9342899,8.80746261 Z"
              id="Path"
              fill="url(#radialGradient-2)"
              opacity={0.9}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M35.9071754,22.0578391 C36.9172928,14.2076606 34.999648,10.2412132 32.3559815,8.79958486 C32.2533914,8.79958486 32.1508014,8.83503474 32.0521571,8.85866799 C34.6405829,10.3239296 36.4950953,14.3021937 35.5125983,22.0578391 C35.1791328,24.6117141 34.4273004,27.093482 33.2871834,29.4038415 C32.3373847,31.4369275 31.113364,33.3307114 29.6491826,35.0324943 L29.8977661,35.2215604 C31.434887,33.4724401 32.7143523,31.5134913 33.6975436,29.4038415 C34.8321989,27.092526 35.5786873,24.6107979 35.9071754,22.0578391 L35.9071754,22.0578391 Z"
              id="Path"
              fill="#FFFFFF"
              opacity={0.8}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M25.9125374,39.8536777 C25.6639538,39.6646117 25.4272076,39.4597902 25.1904613,39.2707242 C21.3078226,40.8896019 15.925791,41.9018929 10.5911086,40.665086 C11.4621765,41.775333 12.4386905,42.7989467 13.5070334,43.7216533 C18.7233426,44.4306508 23.7384176,42.7763232 27.1554553,40.7517413 C26.7490409,40.4720811 26.3347349,40.1766655 25.9125374,39.8536777 Z"
              id="Path"
              fill="url(#radialGradient-3)"
              opacity={0.5}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M25.1904613,39.2707242 L24.8353419,38.9753085 C20.9250828,40.5508586 15.5193766,41.4686166 10.1846942,40.1569711 C10.3149046,40.3342205 10.4490608,40.507531 10.5792713,40.6808415 C15.925791,41.9018929 21.3078226,40.8896019 25.1904613,39.2707242 Z"
              id="Path"
              fill="url(#linearGradientastaricon-4)"
              opacity={0.6}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M8.10527284,31.2039076 C8.13272177,31.2868429 8.16432778,31.3683491 8.19997134,31.4481178 C8.36933217,31.8508455 8.59518535,32.2274938 8.87075241,32.5667584 C8.79578276,29.5771521 11.28951,25.9297535 18.6049695,22.8771252 C20.9902608,21.8854976 23.5234403,21.2945681 26.1019344,21.1282645 C28.4237732,20.929292 30.7621728,21.0619234 33.0464914,21.5221521 C33.1572139,20.619188 33.2099319,19.7100757 33.2043222,18.8003892 C30.5314509,18.1242233 27.7638722,17.900541 25.0168474,18.1386582 C22.4382798,18.3016872 19.9047792,18.8913605 17.5198825,19.88358 C8.81945739,23.5191619 6.94521616,27.9976631 8.10527284,31.2039076 Z"
              id="Path"
              fill="url(#radialGradient-5)"
              opacity={0.9}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M18.6049695,22.8771252 C11.28951,25.9297535 8.79578276,29.5732132 8.87075241,32.5667584 C8.93491889,32.6478421 9.00341135,32.7254189 9.07593251,32.7991521 C9.07593251,29.833179 11.5933344,26.2448636 18.8101496,23.2395017 C21.1954409,22.2478741 23.7286204,21.6569446 26.3071145,21.4906411 C28.5476562,21.2925709 30.804858,21.4039083 33.0149252,21.8215066 C33.0149252,21.7190958 33.0425456,21.6127462 33.0543829,21.5103354 C30.7700644,21.0501068 28.4316647,20.9174754 26.109826,21.1164479 C23.5279804,21.2856532 20.9920408,21.8805974 18.6049695,22.8771252 L18.6049695,22.8771252 Z"
              id="Path"
              fill="#FFFFFF"
              opacity={0.8}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M39.0637922,22.6171594 C39.0243345,22.9243917 38.9730395,23.2276851 38.9177987,23.5309785 C42.2638125,26.0794308 45.8347352,30.2270665 47.4327725,35.4618318 C47.9581797,34.1509935 48.3546232,32.7922497 48.6165038,31.4047902 C46.6436183,26.5442181 42.6978473,23.0346802 39.2176773,21.0928147 C39.170328,21.5851741 39.119033,22.0893501 39.0637922,22.6171594 Z"
              id="Path"
              fill="url(#radialGradient-6)"
              opacity={0.4}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M38.9059613,23.5309785 C38.8822867,23.6845946 38.8586121,23.8382108 38.8270459,23.987888 C42.1375478,26.5875457 45.649284,30.7942645 47.1644601,36.0684186 C47.251267,35.8675359 47.338074,35.674531 47.4209352,35.4618318 C45.8228979,30.2270665 42.2519752,26.0794308 38.9059613,23.5309785 Z"
              id="Path"
              fill="url(#linearGradientastaricon-7)"
              opacity={0.5}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M40.4487578,42.3351691 C40.5079444,42.2682083 40.5631852,42.2012474 40.6144802,42.1303476 C40.8795381,41.7830893 41.093462,41.3997605 41.2497493,40.9920127 C38.6968355,42.5675628 34.2815177,42.2209418 27.9761756,37.4233917 C25.9273444,35.8582108 24.1503841,33.9672523 22.7164629,31.8262499 C21.3760989,29.9217551 20.313295,27.8369952 19.5598461,25.6343379 C18.7215129,25.9899799 17.9069979,26.399157 17.1213596,26.8593281 C17.8753451,29.5094164 19.0704874,32.01403 20.6567704,34.2683525 C22.0896182,36.4102061 23.8667326,38.3013285 25.9164832,39.8654943 C33.4252854,45.5571691 38.2509634,44.9427046 40.4487578,42.3351691 Z"
              id="Path"
              fill="url(#radialGradient-8)"
              opacity={0.9}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M27.9761756,37.4194528 C34.2894093,42.2170029 38.6968355,42.5399907 41.2497493,40.9880738 C41.2852613,40.8935408 41.3168274,40.7950689 41.3483936,40.696597 C38.7796967,42.181553 34.4038366,41.7955432 28.1813557,37.064954 C26.1337611,35.4999508 24.3569712,33.6105042 22.921643,31.4717511 C21.6317017,29.634422 20.6001452,27.6292517 19.8557789,25.5122328 L19.5677376,25.6343379 C20.3211865,27.8369952 21.3839904,29.9217551 22.7243544,31.8262499 C24.1562404,33.9652301 25.9304829,35.8548029 27.9761756,37.4194528 Z"
              id="Path"
              fill="#FFFFFF"
              opacity={0.8}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M17.527774,19.8757022 C17.8118695,19.7575359 18.1038566,19.6472474 18.3918979,19.5408978 C18.94036,15.3617511 20.7435774,10.21758 24.4881141,6.21962154 C23.0865547,6.41455299 21.7079344,6.7483798 20.3726749,7.21615699 C17.14898,11.3677316 16.0757303,16.5434137 16.1230795,20.482289 C16.5728974,20.2892841 17.0384984,20.0884015 17.527774,19.8757022 Z"
              id="Path"
              fill="url(#radialGradient-9)"
              opacity={0.3}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M18.3918979,19.5408978 L18.8259327,19.3833428 C19.4296356,15.2199516 21.3236057,10.0836582 25.1391663,6.13690516 L24.4881141,6.21962154 C20.7435774,10.21758 18.94036,15.3617511 18.3918979,19.5408978 Z"
              id="Path"
              fill="url(#linearGradientastaricon-10)"
              opacity={0.4}
              style={{
                mixBlendMode: 'overlay',
              }}
            />
            <path
              d="M25.6481707,0.063159454 C18.3920801,0.542480563 11.6242634,3.88080069 6.83473457,9.34314966 L6.72819876,9.46525479 L6.72819876,9.46525479 C7.62783455,10.3554406 10.5713797,12.112179 11.7630026,12.8448098 C14.1361476,10.2945899 17.0950172,8.35880211 20.3845122,7.20434037 C20.6173127,6.90498585 20.8580047,6.60563132 21.1144799,6.31809343 C24.2198016,2.82037216 28.4615055,0.973039648 33.3818819,0.973039648 C33.9303441,0.973039648 35.0430515,1.0596949 35.0667262,1.0596949 C32.0088528,0.184801945 28.8218247,-0.15240333 25.6481707,0.063159454 L25.6481707,0.063159454 Z"
              id="Path"
              fill="url(#linearGradientastaricon-11)"
              opacity={0.4}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M28.9547269,48.8421911 C23.3312662,49.2299228 17.7812184,47.3902157 13.5070334,43.7216533 L13.5070334,43.7216533 C13.1124562,43.666509 12.737608,43.603487 12.3509224,43.5247095 C7.76199076,42.5951349 4.03718293,39.8536777 1.57896759,35.5996924 C1.30678112,35.1309897 1.0591789,34.6484832 0.837162637,34.1541252 C4.08668554,47.0262751 16.0978269,55.7328159 29.365087,54.8332205 C29.4242736,53.4467364 29.0139134,50.2326141 28.9547269,48.8421911 Z"
              id="Path"
              fill="url(#linearGradientastaricon-12)"
              opacity={0.4}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M54.9297374,25.6028269 C54.0853424,25.5161716 49.9580659,25.8391594 48.9440028,25.9967144 C49.069923,27.81626 48.9611821,29.6444157 48.6204496,31.4363012 C48.7664431,31.7829222 48.9005993,32.137421 49.0150267,32.4997975 C50.4986366,36.9349711 49.9817406,41.5276997 47.5235252,45.781685 C47.2572529,46.2413157 46.9675149,46.6869954 46.6554556,47.1169638 L46.6554556,47.1445359 L46.6751845,47.1248415 C52.4654542,41.5130802 55.4851318,33.6399047 54.9297374,25.6028269 Z"
              id="Path"
              fill="url(#linearGradientastaricon-13)"
              opacity={0.4}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M33.6659774,7.13737949 C34.2871565,7.20396853 34.8995313,7.33599975 35.4928694,7.53126702 L35.5717848,7.55490027 L35.5717848,7.55490027 C37.931061,8.51756399 40.1016398,9.88830582 41.9836627,11.6040641 L41.9836627,11.6040641 C42.7879218,10.7929995 43.6783485,10.0718652 44.6391666,9.45343816 C42.761311,7.6938414 40.444797,6.46959494 37.9313559,5.9084504 C35.0825092,5.3176191 28.658794,4.72678781 24.6064872,11.6316362 L24.6459449,11.5922475 C24.9401896,11.1371484 25.2672379,10.70404 25.6244961,10.2963575 C27.6335639,8.0043974 30.6309968,6.82689985 33.6659774,7.13737949 Z"
              id="Path"
              fill="url(#linearGradientastaricon-14)"
              opacity={0.5}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M42.0349578,42.9338782 C41.6645267,43.4370723 41.2397752,43.8980667 40.7683653,44.3085457 L40.7091787,44.3676288 L40.7091787,44.3676288 C38.6974556,45.9250849 36.4269026,47.1170419 34.001368,47.8889833 L34.001368,47.8889833 C34.3077353,48.9869538 34.4942708,50.1147756 34.5577217,51.2527828 C37.032136,50.5092927 39.2605066,49.1147433 41.0090573,47.2154356 C42.9464309,45.0490542 46.6554556,39.7788391 42.7096846,32.8346019 C42.7096846,32.8346019 42.7096846,32.8582352 42.7096846,32.8897462 C42.9545848,33.3726439 43.166816,33.8713709 43.3449537,34.3825799 C44.3231141,37.2764326 43.8347859,40.4641067 42.0349578,42.9338782 Z"
              id="Path"
              fill="url(#linearGradientastaricon-15)"
              opacity={0.5}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M6.79527686,32.2989149 C6.54361897,31.7277845 6.35572036,31.1307299 6.23497738,30.5185433 C6.22697812,30.4913288 6.22039305,30.4637198 6.21524852,30.4358269 L6.21524852,30.4358269 C5.8664967,27.9077081 5.96936233,25.3378945 6.51907289,22.8456142 L6.51907289,22.8456142 C5.41308649,22.562484 4.3413769,22.1596443 3.32299837,21.6442572 C2.73095798,24.1558643 2.8263566,26.7801833 3.59920234,29.2423477 C4.51067545,31.9995604 7.22931167,37.8369736 15.2234437,37.9078733 L15.1721487,37.9078733 C14.6302855,37.8796506 14.0910445,37.813844 13.5583284,37.7109295 C10.5572349,37.1105225 8.03527395,35.0923671 6.79527686,32.2989149 Z"
              id="Path"
              fill="url(#linearGradientastaricon-16)"
              opacity={0.5}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M32.5098665,17.858998 C32.725835,17.8852047 32.9434235,17.895736 33.1609188,17.8905091 C33.0928372,16.4367497 32.9267389,14.989219 32.6637516,13.5577462 C32.3165238,12.0924846 31.795682,11.1235213 31.227491,10.5760176 C30.8329139,10.1821301 29.5347552,9.69370956 28.5364751,12.710888 C28.3765958,13.9200451 28.7059249,15.1429611 29.4516085,16.1091033 C30.1972921,17.0752455 31.2978676,17.7049802 32.5098665,17.858998 Z"
              id="Path"
              fill="url(#linearGradientastaricon-17)"
              opacity={0.6}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M16.6715417,27.9110078 C16.5879908,27.7106791 16.4890518,27.5170975 16.3756089,27.3319931 C15.1534947,28.1211524 13.985575,28.9909557 12.8796558,29.9355897 C11.7866772,30.9715139 11.2027031,31.9050274 11.0093603,32.6691692 C10.8752041,33.2166728 11.0922215,34.5755848 14.2093806,33.9296093 C15.3375652,33.4600248 16.2316998,32.5608833 16.6938207,31.4312572 C17.1559416,30.3016311 17.1479235,29.0347151 16.6715417,27.9110078 Z"
              id="Path"
              fill="url(#linearGradientastaricon-18)"
              opacity={0.5}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M33.3108581,36.5725946 C33.1801899,36.7468495 33.0615431,36.9297727 32.9557387,37.1200983 C34.2457113,37.7867319 35.5798674,38.36447 36.9488589,38.8492645 C38.3930111,39.2786019 39.4899355,39.3179907 40.2514693,39.0974137 C40.7959857,38.9437975 41.8613438,38.077245 39.7464106,35.706042 C38.7781695,34.9682835 37.5558247,34.6450687 36.3486903,34.8076104 C35.1415559,34.9701521 34.0486824,35.6051129 33.3108581,36.5725946 L33.3108581,36.5725946 Z"
              id="Path"
              fill="url(#linearGradientastaricon-19)"
              opacity={0.6}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M32.3204695,24.7480909 C31.778719,26.5819321 30.9817902,28.3307855 29.9530069,29.9434675 C29.9017119,30.022245 29.8504169,30.1049613 29.7951761,30.1837389 L29.7951761,30.1837389 C29.0913544,31.1725298 28.298939,32.0953989 27.4277135,32.9409516 C28.0730846,33.6267508 28.7610053,34.2713716 29.4874059,34.8710005 C30.3384158,35.5380365 31.2378971,36.1410313 32.1784218,36.6750053 C34.0874255,34.7086834 35.655559,32.4391298 36.8186485,29.959223 C37.2320814,29.1154154 37.5969994,28.2487703 37.911627,27.3635041 C37.0257327,26.7050211 36.0688569,26.1474887 35.0588346,25.7012988 C34.1680027,25.3238862 33.253234,25.0054609 32.3204695,24.7480909 Z"
              id="Path"
              fill="url(#linearGradientastaricon-20)"
              opacity={0.3}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M13.5070334,43.7216533 C18.7233426,44.4306508 23.7384176,42.7763232 27.1554553,40.7517413 C26.7608782,40.4681423 26.3347349,40.1687877 25.9125374,39.8497388 C24.6136015,38.8577269 23.4232665,37.7315254 22.3613435,36.4898782 C19.7887008,37.6124577 16.5571143,38.2702498 13.5543826,37.6715408 C10.5543172,37.0747434 8.03118515,35.061234 6.78738532,32.2713428 C6.53677321,31.6994702 6.34763338,31.1026744 6.22314007,30.4909711 C6.96036489,35.6380764 9.54957423,40.3411939 13.5070334,43.7216533 L13.5070334,43.7216533 Z"
              id="Path"
              fill="url(#linearGradientastaricon-21)"
              opacity={0.3}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M27.4198219,32.9724626 C26.1039936,31.5824408 24.9896696,30.0153025 24.1093201,28.316712 C24.0659166,28.2300567 24.0185673,28.1473403 23.9791096,28.0606851 L23.9791096,28.0606851 C23.464142,26.9599587 23.0520343,25.814139 22.7480291,24.6378024 C21.8319893,24.8505755 20.9305146,25.1215978 20.0491217,25.4492107 C19.0459097,25.8479489 18.0750011,26.3233368 17.1450342,26.8711447 C17.8923726,29.5150915 19.0780378,32.0154155 20.6528247,34.2683525 C21.1772293,35.046368 21.7463751,35.7933815 22.3573977,36.5056337 C23.3724557,36.0708363 24.3348051,35.5224498 25.2259733,34.8710005 C25.9992292,34.2881681 26.7321792,33.6538795 27.4198219,32.9724626 Z"
              id="Path"
              fill="url(#linearGradientastaricon-22)"
              opacity={0.3}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M20.3687291,7.22403475 C17.1450342,11.3756093 16.0717845,16.5434137 16.1191338,20.5059222 C16.5689517,20.293223 17.0384984,20.0844626 17.527774,19.8796411 C19.0366987,19.2512194 20.6079594,18.7838338 22.21535,18.4852792 C22.5270659,15.7004944 23.5726952,12.5769663 25.6047673,10.2924186 C27.6196279,7.99735626 30.6256978,6.82229354 33.6659774,7.14131836 C34.2871565,7.20790741 34.8995313,7.33993862 35.4928694,7.53520589 L35.5717848,7.55883915 L35.5717848,7.55883915 C30.7228395,5.58755306 25.3183004,5.45863133 20.3805665,7.19646262 L20.3805665,7.19646262 L20.3687291,7.22403475 Z"
              id="Path"
              fill="url(#linearGradientastaricon-23)"
              opacity={0.3}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M48.612558,31.4008513 C46.6159979,26.5363403 42.6939015,23.0268024 39.2058399,21.0849369 C39.1624365,21.5772963 39.1111414,22.0854112 39.0440633,22.6132205 C38.8363966,24.2322554 38.4567818,25.8246433 37.911627,27.3635041 C40.1686081,29.0257095 42.3624567,31.4914455 43.3291706,34.3943965 C44.3131589,37.2817404 43.8305154,40.4663211 42.0349578,42.9338782 C41.6648518,43.4373122 41.2415308,43.8995105 40.772311,44.3124845 L40.772311,44.3124845 C44.8581297,41.1038398 47.6452269,36.5297419 48.6204496,31.4323623 C48.6204496,31.4323623 48.6204496,31.4323623 48.6204496,31.4008513 L48.612558,31.4008513 Z"
              id="Path"
              fill="url(#linearGradientastaricon-24)"
              opacity={0.3}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
            <path
              d="M22.1995669,21.7860567 C22.316077,22.74368 22.4966709,23.6924439 22.7401375,24.6259858 C24.6047874,24.1812731 26.5226721,23.9996311 28.4378309,24.0863599 L28.7298179,24.0863599 L28.7298179,24.0863599 C29.9400347,24.1897626 31.1380762,24.4046904 32.3086322,24.7283966 C32.5822895,23.8241146 32.797124,22.9031248 32.9517929,21.9711839 C33.1081508,20.9017904 33.1820223,19.8219907 33.1727561,18.7413061 C30.5082418,18.0792222 27.7512118,17.8688451 25.0168474,18.1189638 C24.0768906,18.1825116 23.1414612,18.30088 22.21535,18.4734626 C22.0831571,19.5734218 22.0778614,20.684892 22.1995669,21.7860567 L22.1995669,21.7860567 Z"
              id="Path"
              fill="url(#linearGradientastaricon-25)"
              opacity={0.3}
              style={{
                mixBlendMode: 'multiply',
              }}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)
